// extracted by mini-css-extract-plugin
module.exports = {"content":"deckDetailsFetchingOverlayWrapper_content__LtpKr"};